import { i18n } from '@flowus/common/i18n';
import {
  cacheDateTimeStamp,
  cacheDateStamp,
  cacheDateMomentStamp,
  cacheDateHourStamp,
} from 'src/services/global-cache';

export const MONTHS = [
  i18n.t('components.date_utils.january'),
  i18n.t('components.date_utils.february'),
  i18n.t('components.date_utils.march'),
  i18n.t('components.date_utils.april'),
  i18n.t('components.date_utils.may'),
  i18n.t('components.date_utils.june'),
  i18n.t('components.date_utils.july'),
  i18n.t('components.date_utils.august'),
  i18n.t('components.date_utils.september'),
  i18n.t('components.date_utils.october'),
  i18n.t('components.date_utils.november'),
  i18n.t('components.date_utils.december'),
];
export const WEEKDAYS_SHORT = [
  i18n.t('common.day_suffix'),
  i18n.t('components.date_utils.monday_short'),
  i18n.t('components.date_utils.tuesday_short'),
  i18n.t('components.date_utils.wednesday_short'),
  i18n.t('components.date_utils.thursday_short'),
  i18n.t('components.date_utils.friday_short'),
  i18n.t('components.date_utils.saturday_short'),
];
export const WEEKDAYS_LONG = [
  i18n.t('components.date_utils.sunday_long'),
  i18n.t('components.date_utils.monday_long'),
  i18n.t('components.date_utils.tuesday_long'),
  i18n.t('components.date_utils.wednesday_long'),
  i18n.t('components.date_utils.thursday_long'),
  i18n.t('components.date_utils.friday_long'),
  i18n.t('components.date_utils.saturday_long'),
];
export const ONE_MINUTES = 60 * 1000;
export const ONE_MOMENT = 15 * ONE_MINUTES;
export const ONE_HOURS = 4 * ONE_MOMENT;
export const ONE_DAY = 24 * ONE_HOURS;

export const getDateTimeStamp = (time: number) => {
  if (cacheDateTimeStamp.has(time)) {
    return cacheDateTimeStamp.get(time);
  }
  const result = new Date(new Date(time).toDateString()).getTime();
  cacheDateTimeStamp.set(time, result);
  return result;
};

export const getDateHourStamp = (time: number) => {
  if (cacheDateStamp.has(time)) {
    return cacheDateStamp.get(time);
  }
  const result = new Date(time).setHours(new Date(time).getHours(), 0, 0, 0);
  cacheDateStamp.set(time, result);
  return result;
};

export const getDateMomentStamp = (time: number) => {
  if (cacheDateMomentStamp.has(time)) {
    return cacheDateMomentStamp.get(time);
  }
  const hours = getDateHourStamp(time);
  const result = hours + Math.floor((time - hours) / ONE_MOMENT) * ONE_MOMENT;
  cacheDateMomentStamp.set(time, result);
  return result;
};

export const getMonday = (time: number = Date.now()) => {
  if (cacheDateHourStamp.has(time)) {
    return cacheDateHourStamp.get(time);
  }
  const result = getDateTimeStamp(time) - ((new Date(time).getDay() || 7) - 1) * ONE_DAY;
  cacheDateHourStamp.set(time, result);
  return result;
};

export const formatWeekText = (str: string) => {
  if (__BUILD_IN__) {
    return str;
  }
  return [i18n.t('common.week'), str].join('');
};
